import { styled } from '@mui/system';

export default styled('div')`
  word-break: break-word;
  word-wrap: break-word;
`;
